import { ArrowLeft, Loader2 } from "lucide-react";
import { FormField } from "@/components/common/FormField";
import { ResumeUpload } from "@/components/common/ResumeUpload";
import { InquiryFields } from "./InquiryFields";

const AnswerSummary = ({ summary }) => {
  if (!summary.length) return null;
  return (
    <div className="mt-6 rounded-xl border border-border bg-slate-50 p-4" data-testid="answer-summary">
      <p className="text-xs font-semibold uppercase tracking-[0.16em] text-slate-400">Your answers</p>
      <ul className="mt-2 space-y-1">
        {summary.map((answer) => (
          <li key={answer.id} className="text-sm text-slate-600" data-testid={`answer-summary-${answer.id}`}>
            <span className="font-medium text-slate-800">{answer.label}:</span> {answer.text}
          </li>
        ))}
      </ul>
    </div>
  );
};

export const DetailsStep = ({ journey }) => {
  const { selectedPath, form, pathId, updateField, submitting } = journey;
  if (!selectedPath) return null;
  return (
    <>
      <button onClick={journey.backToQuestions} data-testid="details-back"
        className="mb-6 inline-flex items-center gap-1.5 text-sm font-medium text-slate-500 transition-colors hover:text-slate-900">
        <ArrowLeft className="h-4 w-4" /> Back
      </button>
      <p className="overline">{selectedPath.label}</p>
      <h2 className="mt-3 font-heading text-2xl font-extrabold tracking-tight text-slate-900 md:text-3xl">
        Last step — where should we reach you?
      </h2>
      <AnswerSummary summary={journey.summary} />
      <form onSubmit={journey.handleSubmit} className="mt-6 grid gap-5" data-testid="inquiry-form" noValidate>
        <InquiryFields journey={journey} />
        <FormField label={pathId === "employer" ? "Requirement details" : "Anything else you'd like to add? (optional)"} testId="inquiry-message">
          <textarea rows={3} className="scc-input resize-none" value={form.message} data-testid="inquiry-message"
            onChange={(event) => updateField("message", event.target.value)} placeholder="Any extra context that would help us respond well." />
        </FormField>
        {pathId === "candidate" && (
          <div className="rounded-xl border border-border bg-blue-50 p-5" data-testid="candidate-resume-block">
            <p className="text-sm font-semibold text-slate-900">Add your resume (optional)</p>
            <p className="mt-1 text-xs text-slate-500">Helps us tailor your career support. PDF or DOCX, up to 1 MB.</p>
            <ResumeUpload source="candidate-journey" name={form.name} email={form.email}
              phone={form.phone ? `${form.phoneDial}${form.phone}` : ""} className="mt-4" testIdPrefix="candidate-resume" />
          </div>
        )}
        <label className="flex items-start gap-3 text-sm text-slate-600">
          <input type="checkbox" checked={form.consent} data-testid="inquiry-consent"
            onChange={(event) => updateField("consent", event.target.checked)} className="mt-1 h-4 w-4 rounded border-slate-300 text-blue-600" />
          <span>I agree to be contacted by SCC about my enquiry.</span>
        </label>
        <button type="submit" disabled={submitting} data-testid="inquiry-submit"
          className="inline-flex items-center justify-center gap-2 rounded-full bg-primary px-8 py-4 font-medium text-primary-foreground transition-[background-color,transform] duration-300 hover:bg-blue-700 active:scale-[0.98] disabled:opacity-60">
          {submitting && <Loader2 className="h-4 w-4 animate-spin" />}
          {submitting ? "Sending…" : "Send it to SCC"}
        </button>
        <p className="text-xs text-slate-400">We only use these details to respond to your request.</p>
      </form>
    </>
  );
};